<h1>Kademy admin</h1><router-view :key="$route.params.namespace"></router-view>